import React, { useEffect, useRef } from "react";

interface PdfReaderProps {
    pdfUrl: string;
    id: string;
}

const PdfReader: React.FC<PdfReaderProps> = ({ pdfUrl, id }) => {
    // This fixes the issue with the back button navigation being hijacked by the iframe navigation
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        if (pdfUrl && iframeRef.current) {
            iframeRef.current.contentWindow?.location.replace(pdfUrl);
        }
    }, [pdfUrl]);

    return (
        <iframe
            ref={iframeRef}
            key={id}
            src={pdfUrl}
            width="100%"
            height="1200px"
            style={{ border: "none", minHeight: "90vh" }}
        />
    );

};

export default PdfReader;
